<template>
<div class="phoneDialogWraper">
  <div id="phoneDialogId" class="phoneDialog">
    <div class="phoneInputWrapper">
      <div class="phoneInputtitle">输入手机号领取企业报告</div>
      <div class="phoneInputPicWrapper">
        <img src="../../assets/numberInput.png" class="phoneInputPic" />
      </div>
      <div class="inputNumberContent">实时跟踪企业估值(仅限大陆手机号)</div>
      <div class="inputCompany">当企业有信息变动,会第一时间反馈给用户</div>
      <div class="inputNumberButtonWrapper">
        <input
          @focus="inputFocus"
          @blur="inputBlur"
          class="inputNumberButton"
          v-model="phoneNumber"
        />
        <div v-show="inputBgShow" class="inputNumberText">
          请输入手机号码领取
        </div>
        <div v-show="validator" class="warningText">请输入大陆手机号</div>
      </div>
      <div class="inputNumberSaveButton">
        <button @click="goBack" class="inputNumberSaveButtonText">
          领取报告
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { loginMobileNumber } from "../../api/api";
export default {
  name: "commonDialog",
  props: ["type", "errMsg"],
  data() {
    return {
      dialogImgSrc: "",
      validator: false,
      validatorShow: false,
      inputBgShow: true,
      phoneNumber: "",
      saveReport: { acccessToken: "12345678" },
    };
  },
  created() {},
  methods: {
    goBack() {
      let re = /^1\d{10}$/;
      if (!re.test(this.phoneNumber)) {
        this.validator=true
        return;
      }
      const params = {
        phone: this.phoneNumber,
        appName: "modgo-30",
        linkNumber: this.$route.query.n||"",
        userSource: "14",
      };
      loginMobileNumber(params).then(
        (res) => {
          console.log("res", res);
          if (res) {
            localStorage.setItem('token',res.accessToken)
            console.log(localStorage.getItem('token'),123)
            if(localStorage.getItem('token')){
             this.$emit("dialogGoBack", false, JSON.stringify(res))
            // this.$emit("dialogGoBack", false, JSON.stringify(res));
            }
          }
        },
        (err) =>  this.$emit("dialogGoBack", false, JSON.stringify(err),'error')
      );
      // this.$emit('dialogGoBack', false, JSON.stringify(this.saveReport))
    },
    inputFocus() {
      this.inputBgShow = false;
    },
    inputBlur() {
      if (this.phoneNumber) {
        this.inputBgShow = false;
      } else {
        this.inputBgShow = true;
      }
      let re = /^1\d{10}$/;
      if (!re.test(this.phoneNumber)) {
        this.validator = true;
      } else {
        this.validator = false;
      }
    },
  },
};
</script>

<style lang='less'>
.phoneDialogWraper{
  position: absolute;
.phoneDialog {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
}
.phoneInputWrapper {
  width: 6.31rem;
  height: 8.2rem;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -3.155rem;
  margin-top: -4.1rem;
  background-color: #fff;
  border-radius: 0.2rem;
}
.phoneInputtitle {
  font-size: 0.48rem;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: center;
  color: #5883ff;
  line-height: 0.84rem;
  margin-top: 0.45rem;
}
.phoneInputPicWrapper {
  width: 2.98rem;
  height: auto;
  margin: 0 auto;
}
.phoneInputPic {
  width: 100%;
  height: auto;
}
.inputNumberContent {
  font-size: 0.24rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ed7d31;
  margin-top: 0.06rem;
  line-height: 0.36rem;
}
.inputCompany {
  font-size: 0.18rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #999999;
  line-height: 0.54rem;
  padding-bottom: 0.12rem;
}

.inputNumberButtonWrapper {
  position: relative;
  width: 5.6rem;
  height: 0.72rem;
  margin: 0.03rem auto;
  border: 0.02rem solid #5983ff;
  border-radius: 0.13rem;
}
.inputNumberButton {
  background-color: transparent;
  display: inline-block;
  width: 5.6rem;
  height: 0.72rem;
  border: 0;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 0.4rem;
  box-sizing: border-box;
  padding: 0 0.1rem;
  text-align: center;
}
.inputNumberText {
  width: 5.6rem;
  line-height: 0.72rem;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 0.26rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #969caa;
  z-index: 1;
}
.inputNumberSaveButton {
  width: 5.6rem;
  height: 0.72rem;
  background: #5883ff;
  border-radius: 0.11rem;
  margin: 0 auto;
}
.inputNumberSaveButtonText {
  display: block;
  font-size: 0.3rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 0.72rem;
  margin-top: 0.5rem;
  width: 100%;
  background-color: transparent;
  border: 0;
}
.buttonGroup {
  display: flex;
  justify-content: center;
  background-color: #fff;
  padding: 0.3rem 0 0.7rem 0;
}
.buttonMargin {
  margin-right: 0.5rem;
}

.reportButton {
  width: 3.8rem;
  height: 1.2rem;
  background-color: #5883ff;
  text-align: center;
  font-size: 0.6rem;
  line-height: 1.2rem;
  color: #fff;
  font-weight: 100;
  border-radius: 0.1rem;
  border: 0;
}

.warningText {
  // font-size: 0.1rem;
  font-size:0.24rem;
  margin-top: 0.8rem;
  color: red;
  text-align: center;
}
}
</style>



// WEBPACK FOOTER //
// src/components/saveReport/saveReport.vue